import api_search from "../../../api/search";
import intlTelInput from "../../../components/forms/intlTelInput";
import searchSelect from "../../../components/forms/searchSelect";
import formValidation from "../../../components/forms/formValidation";
import select from "../../../components/forms/select";
import toast from "../../../components/toasts";
import errorHandler from "../../../api/errorHandler";
import scrollTo from "../../../components/scrollTo";
import fixedHeader from "../components/fixedHeader";
import menuHighlight from "../components/menuHighlight";
import notify from "../../../components/notify";
import modal from "../../../components/modal";
import landingFeedback from "../components/feedback";
import lazyLoad from "../../../components/lazyLoad";
import animationCommon from "../components/animation";
import animation from "./animation";
import scrollbar from "../../../components/scrollbar";
import landingRedragonPage from "./index";
import models from "./models";

const landingRedragonComponents = [
    api_search,

    lazyLoad.bind(null, 200),
    intlTelInput,
    searchSelect,
    formValidation,
    select,
    toast,
    errorHandler,
    scrollTo,
    fixedHeader,
    menuHighlight,
    notify,
    modal,
    scrollbar,
    animationCommon.bind(landingRedragonPage),
    animation,
    landingFeedback,
    models
];

export default landingRedragonComponents;
